import { hexaToName } from '../../../../libs/color-picker/name-that-color';

let cachedLibraries = {};

(function () {
    'ngInject';

    angular.module('app.shared.services').factory('LibrariesAPIService', librariesAPIService);

    function librariesAPIService(HttpService) {
        function cloneLibrary(libraryId) {
            var data = {
                sourceId: libraryId
            };
            return HttpService.post('/Libraries?' + $.param(data));
        }

        function createLibrary(name, colorMode, type) {
            var data = {
                name: name,
                colorMode: colorMode,
                type: type
            };
            return HttpService.post('/Libraries?' + $.param(data));
        }

        function getLibrary(id) {
            return HttpService.get('/Libraries/' + id);
        }

        function getLibraries(args) {
            const { searchString, from, num, type, deleted = false, excludeLibrariesWithCategories = false } = args;
            var data = {
                searchString: searchString,
                from: from,
                num: num,
                type: type,
                deleted: deleted,
                excludeLibrariesWithCategories: excludeLibrariesWithCategories
            };
            return HttpService.get('/Libraries?' + $.param(data));
        }

        function getLibrariesCount(args) {
            const { searchString, type, deleted = false, excludeLibrariesWithCategories = false } = args;
            var data = {
                searchString: searchString,
                type: type,
                deleted: deleted,
                excludeLibrariesWithCategories: excludeLibrariesWithCategories
            };
            return HttpService.get('/Libraries/Count?' + $.param(data));
        }

        function getLibraryElementsCount(libraryId) {
            return HttpService.get('/Libraries/' + libraryId + '/Elements/Count');
        }

        function getLibraryElementsLastPosition(libraryId) {
            return HttpService.get('/Libraries/' + libraryId + '/Elements/Position/Last');
        }

        function getLibraryElementsLastSort(libraryId, categoryId = null) {
            let data = {
                categoryId
            };
            return HttpService.get('/Libraries/' + libraryId + '/Sort/Last' + '?' + $.param(data));
        }

        function getLibraryElements(searchString, from, num, libraryId) {
            var data = {
                searchString: searchString,
                from: from,
                num: num
            };
            return HttpService.get('/Libraries/' + libraryId + '/Elements?' + $.param(data));
        }

        async function getLibraryElementAtPosition(libraryId, elementPosition) {
            if (!libraryId || !elementPosition) {
                return null;
            }

            const cachedElement = cachedLibraries[`${libraryId}-${elementPosition}`];
            if (cachedElement) {
                return cachedElement;
            }

            return HttpService.get('/Libraries/' + libraryId + '/Elements/Position/' + elementPosition + '/Private');
        }

        async function getLibrariesElementAtPosition(payload) {
            if (!payload?.libraryIds?.length) {
                return;
            }

            const response = await HttpService.put('/Libraries/Elements/Private', payload);
            cachedLibraries = { ...cachedLibraries, ...response.reduce((acc, element) => {
                acc[`${element.Library_LibraryId}-${element.position}`] = element;
                return acc;
            }, {}) };
        }

        function getLibraryCategoriesCount(libraryId) {
            return HttpService.get('/Libraries/' + libraryId + '/Categories/Count');
        }

        function getLibraryCategories(searchString, from, count, libraryId) {
            var data = {
                searchString: searchString,
                from: from,
                count: count
            };
            return HttpService.get('/Libraries/' + libraryId + '/Categories?' + $.param(data));
        }

        function getElementsByCategoryCount(libraryId, categoryId) {
            return HttpService.get('/Libraries/' + libraryId + '/Categories/' + categoryId + '/Elements/Count');
        }

        function getElementsByCategory(searchString, from, count, libraryId, categoryId) {
            var data = {
                searchString: searchString,
                from: from,
                count: count
            };
            return HttpService.get(
                '/Libraries/' + libraryId + '/Categories/' + categoryId + '/Elements/Private?' + $.param(data)
            );
        }

        function deleteLibrary(id) {
            return HttpService.delete('/Libraries/' + id);
        }

        function editLibrary(id, name) {
            var data = {
                name: name
            };
            return HttpService.put('/Libraries/' + id + '?' + $.param(data));
        }

        function addElement(id, position, element, type, name = null, Sort = null) {
            // Default name
            if (!name) {
                if (type.toLowerCase() === 'color') {
                    name = hexaToName(element.hex)[1]; // [1] is the name
                } else {
                    name = 'My ' + type + ' ' + position; // Example: My color 1
                }
            }

            const data = {
                element: JSON.stringify(element),
                position,
                type,
                name,
                Sort
            };

            return HttpService.post('/Libraries/' + id + '?' + $.param(data));
        }

        function uploadLibrary(name, identifier) {
            let data = {
                ZipName: name,
                ZipIdentifier: identifier
            };

            return HttpService.post('/Libraries/BulkUpload', data);
        }

        function uploadLibraryProgress(progressIdentifier) {
            return HttpService.get('/TasksProgress/' + progressIdentifier);
        }

        function updateElement(id, elementId, element, type) {
            var data = {
                element: JSON.stringify(element),
                type: type
            };
            return HttpService.put('/Libraries/' + id + '/' + elementId + '?' + $.param(data));
        }

        function deleteElement(id, position) {
            return HttpService.delete('/Libraries/' + id + '/' + position);
        }

        function getCategory(libraryId, categoryId) {
            return HttpService.get('/Libraries/' + libraryId + '/Categories/' + categoryId);
        }

        function addCategory(id, category) {
            var data = {
                category: JSON.stringify(category)
            };
            return HttpService.post('/Libraries/' + id + '/Categories?' + $.param(data));
        }

        function updateCategory(id, categoryId, category) {
            var data = {
                category: JSON.stringify(category)
            };
            return HttpService.put('/Libraries/' + id + '/Categories/' + categoryId + '?' + $.param(data));
        }

        function deleteCategory(id, categoryId) {
            return HttpService.delete('/Libraries/' + id + '/Categories/' + categoryId);
        }

        function getLibraryName(libraryId) {
            return HttpService.get('/Libraries/' + libraryId + '/Name');
        }

        function updateSort(libraryId, categoryId = null, type, sortType, isCategory = false) {
            let url = `/Libraries/${libraryId}/Sort`;
            if (isCategory) {
                url = `/Libraries/${libraryId}/Categories/Sort`;
            }
            let data = {
                sortType: sortType,
                type: type,
                categoryId
            };
            return HttpService.put(url + '?' + $.param(data));
        }

        function syncSortElements(libraryId, categoryId = null, isCategory = false) {
            let url = `/Libraries/${libraryId}/Sort/Sync`;
            if (isCategory) {
                url = `/Libraries/${libraryId}/Categories/Sort/Sync`;
            }
            let data = {
                categoryId
            };
            return HttpService.post(url + '?' + $.param(data));
        }

        function getTaskLibrary(libraryId, categoryId = null) {
            let data = {
                categoryId
            };
            return HttpService.get('/Libraries/' + libraryId + '/TaskProgress/Library' + '?' + $.param(data));
        }

        function getTaskProgress(taskId, libraryId) {
            let data = {
                taskProgressId: taskId
            };
            return HttpService.get(`/Libraries/${libraryId}/TaskProgress?` + $.param(data));
        }

        function clearCachedLibraries() {
            cachedLibraries = {};
        }

        function extractLibraryIdsFromElement(element, libraryIdKeys) {
            const libraryIds = [];
            for (const key of libraryIdKeys) {
                if (element[key]) {
                    libraryIds.push(element[key]);
                }
            }
            return libraryIds;
        }

        function extractLibraryIdsFromElements(elements, libraryIdKeys) {
            const libraryIds = [];
            for (const element of elements) {
                libraryIds.push(...extractLibraryIdsFromElement(element, libraryIdKeys));
            }
            return libraryIds;
        }

        function getLibraryPositionsFromListEps(listEps) {
            if (!listEps || !Array.isArray(listEps)) {
                return undefined;
            }

            const libraries = [];

            const elementTypeConfigs = [
                {
                    key: 'textsEps',
                    libraryIdKeys: ['outlineColorLibraryId', 'colorLibraryId', 'fontLibraryId', 'strokeColorLibraryId', 'shadowColorLibraryId']
                },
                {
                    key: 'circularTextsEps',
                    libraryIdKeys: ['outlineColorLibraryId', 'colorLibraryId', 'fontLibraryId']
                },
                {
                    key: 'imagePlaceHoldersEps',
                    libraryIdKeys: ['imageLibraryId', 'colorLibraryId']
                },
                {
                    key: 'vectorEPSEps',
                    libraryIdKeys: ['vectorLibraryId', 'colorLibraryId']
                }
            ];

            for (const eps of listEps) {
                for (const config of elementTypeConfigs) {
                    const elements = eps[config.key] || [];
                    libraries.push(...extractLibraryIdsFromElements(elements, config.libraryIdKeys));
                }
            }

            const uniqueLibraries = [...new Set(libraries.filter(Boolean))];

            const payload = {
                libraryIds: uniqueLibraries,
                position: 1
            }

            return payload;
        }

        function getLibraryPositionsFromPreview(preview) {
            if (!preview) {
                return undefined;
            }

            const libraries = [];

            const elementTypeConfigs = [
                {
                    key: 'texts',
                    libraryIdKeys: ['outlineColorLibraryId', 'colorLibraryId', 'fontLibraryId', 'strokeColorLibraryId', 'shadowColorLibraryId']
                },
                {
                    key: 'circularTexts',
                    libraryIdKeys: ['outlineColorLibraryId', 'colorLibraryId', 'fontLibraryId']
                },
                {
                    key: 'imagePlaceHolders',
                    libraryIdKeys: ['imageLibraryId', 'colorLibraryId']
                },
                {
                    key: 'vectorsEps',
                    libraryIdKeys: ['vectorLibraryId', 'colorLibraryId']
                }
            ];

            for (const config of elementTypeConfigs) {
                const elements = preview[config.key] || [];
                libraries.push(...extractLibraryIdsFromElements(elements, config.libraryIdKeys));
            }

            const uniqueLibraries = [...new Set(libraries.filter(Boolean))];

            const payload = {
                libraryIds: uniqueLibraries,
                position: 1
            }

            return payload;
        }

        return {
            createLibrary: createLibrary,
            cloneLibrary: cloneLibrary,
            addElement: addElement,
            addCategory: addCategory,
            uploadLibrary: uploadLibrary,
            uploadLibraryProgress: uploadLibraryProgress,

            getLibrary: getLibrary,
            getLibraries: getLibraries,
            getLibrariesCount: getLibrariesCount,
            getLibraryElementsCount: getLibraryElementsCount,
            getLibraryElements: getLibraryElements,
            getLibraryElementAtPosition: getLibraryElementAtPosition,
            getLibrariesElementAtPosition: getLibrariesElementAtPosition,
            getLibraryElementsLastPosition: getLibraryElementsLastPosition,
            getLibraryElementsLastSort: getLibraryElementsLastSort,
            getCategory: getCategory,
            getLibraryCategoriesCount: getLibraryCategoriesCount,
            getLibraryCategories: getLibraryCategories,
            getElementsByCategoryCount: getElementsByCategoryCount,
            getElementsByCategory: getElementsByCategory,
            getLibraryName: getLibraryName,

            deleteLibrary: deleteLibrary,
            deleteElement: deleteElement,
            deleteCategory: deleteCategory,

            editLibrary: editLibrary,
            updateElement: updateElement,
            updateCategory: updateCategory,
            updateSort: updateSort,
            syncSortElements: syncSortElements,

            getTaskLibrary: getTaskLibrary,
            getTaskProgress: getTaskProgress,
            clearCachedLibraries: clearCachedLibraries,
            getLibraryPositionsFromListEps: getLibraryPositionsFromListEps,
            getLibraryPositionsFromPreview: getLibraryPositionsFromPreview
        };
    }
})();
